// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9fd1d4b8","667":"b38f89bf"}[chunkId] + ".chunk.js";
};